export const initItem = {
  item: "",
  audio: false,
  item_id: 0,
  proposals: [
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
  ],
}

export const initExtra = {
  native_language: undefined,
  wholesome_conditions: undefined,
  finished: false,
  isRestarting: undefined,
  elapsed_time: 0,
  general_audio: false,
}

export const initAnswers = {
  version: "",
  langCode: "",
  locale_id: 0,
  status: "",
  data: {
    items: [],
    extra: initExtra,
  },
}
